module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "body-rw Chapter-rw",
    attrs: {
      "epub:type": "bodymatter chapter",
      "id": "Chapter2"
    }
  }, [_c('div', {
    staticClass: "title-block-rw",
    attrs: {
      "id": "title-block6"
    }
  }, [_c('p', {
    staticClass: "title-num-rw",
    attrs: {
      "id": "title-num3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/TOC"
    }
  }, [_vm._v("Jen")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p227"
    }
  }, [_c('span', {
    staticClass: "raisedcap-rw"
  }, [_vm._v("Funny day")]), _vm._v(" at work. I spend the afternoon watching "), _c('i', [_vm._v("Some Like It Hot")]), _vm._v(" with Aiden. He’s the artificial intelligence we’re training to talk to people—although technically he’s not a "), _c('i', [_vm._v("“he.")]), _vm._v("” Being a machine, he’s gender-neutral. Gender-"), _c('i', [_vm._v("free")]), _vm._v(". I only call him “"), _c('i', [_vm._v("him")]), _vm._v("” because his voice synthesizer is set to “male.” I can set it to female—in fact they say I should, “to provide Aiden with flying hours in both modalities”—but I prefer his male voice. It’s calm, even a bit hypnotic. I’ve set it to contain a hint of a Welsh accent, which seems to suit him. Anyway, calling him “him” is nicer than calling him “it.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p228"
    }
  }, [_vm._v("And I must also stop saying we’re "), _c('i', [_vm._v("training")]), _vm._v(" him. He’s actually training himself. I’m not supposed to correct any of his—now very rare—mistakes; he picks them up himself.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p229"
    }
  }, [_vm._v("Itself.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p230"
    }
  }, [_vm._v("Whatever.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p231"
    }
  }, [_vm._v("Anyway, we’re watching the film when an e-mail pops up on my mobile from Uri, the Israeli-born, LA-based gazillionaire who owns the lab. He’s passing through London briefly so can I (and some other unnamed members of the Aiden team) meet him for drinks at an achingly trendy bar in Hoxton to “talk in an open and unstructured way about how this project goes forward.” And by the way, don’t tell anyone, and please delete after reading.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p232"
    }
  }, [_vm._v("All a bit odd, but that’s Uri apparently; not one for formal meetings, so they say, although I’ve never met the bloke. Cannot imagine who else will be there. Steeeeve, probably, the stooping zombie who helped design Aiden; and the other one, sad Ralph with the Arctic-white skin. Also cannot imagine what I can bring to the party; it’s not like I know how he works or anything. All I can tell them is that most of the time I forget I’m talking to “someone” who’s not really there.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p233"
    }
  }, [_vm._v("The Uri event is this coming Friday; tonight, however, I’m meeting Ingrid, my pal from university, at Café Koha, our favorite dark, cozy wine bar close to the Leicester Square tube.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p234"
    }
  }, [_vm._v("(When I told Aiden I was seeing Ingrid—I sometimes chat with him about life outside the lab—I referred to my old friend as “a brick.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p235"
    }
  }, [_vm._v("“What? Heavy, brown, and rectangular?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p236"
    }
  }, [_vm._v("She thought it was a hoot that an AI could do jokes.)")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p237"
    }
  }, [_vm._v("“So have you spoken to him?” says Ingrid. “Since the apple-chucking incident?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p238"
    }
  }, [_vm._v("She is not one for beating about the bush.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p239"
    }
  }, [_vm._v("“Only to discuss the return of his stuff.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p240"
    }
  }, [_vm._v("“I’d have shoved it in a rubbish bag and left it in the street.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p241"
    }
  }, [_vm._v("“There was a suit, a few shirts. When he arrived to collect them. So stupid. I tried to sit him down. To talk about…”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p242"
    }
  }, [_vm._v("“Jen, if you’d rather not…”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p243"
    }
  }, [_vm._v("“I’m fine.” I gulp some wine in order to continue. “He said he didn’t have time. He had theater tickets. In any case, what was there to talk about, we—”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p244"
    }
  }, [_vm._v("“He didn’t!”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p245"
    }
  }, [_vm._v("“He did. He actually said, "), _c('i', [_vm._v("We are where we are")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p246"
    }
  }, [_vm._v("“Christ. What an absolute arse.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p247"
    }
  }, [_vm._v("“The thing I can’t get past, the thought I keep coming back to, like a dog returning to its sick…we seemed to be puttering along so nicely.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p248"
    }
  }, [_vm._v("“Puttering.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p249"
    }
  }, [_vm._v("“Calm sea. No storm clouds.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p250"
    }
  }, [_vm._v("“Albeit a certain flatness in the sex situation.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p251"
    }
  }, [_vm._v("“It was two years, Ing. You don’t go at it like rabbits after two years. I mean you and Rupert…”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p252"
    }
  }, [_vm._v("“No. No, of course not. But we do go away for "), _c('i', [_vm._v("weekends")]), _vm._v(". Lovely country hotels. Castles and so forth. There was a windmill once. Very romantic.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p253"
    }
  }, [_vm._v("Not sure I want what lawyers call "), _c('i', [_vm._v("further and better particulars, ")]), _vm._v("so I ask:")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p254"
    }
  }, [_vm._v("“Did you ever really like Matt?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p255"
    }
  }, [_vm._v("“Not really, if I’m honest. Those eyes. That cruel emperor look of his.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p256"
    }
  }, [_vm._v("“I used to think, at the beginning, it showed mastery.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p257"
    }
  }, [_vm._v("There is giggling.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p258"
    }
  }, [_vm._v("“He was a cold shit, Jen.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p259"
    }
  }, [_vm._v("“What does it say about me that I stuck with him?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p260"
    }
  }, [_vm._v("“About you? That you’d reached a difficult age, probably. The seas were calm; it was possible he might have been the one for the long haul. But you weren’t thinking about what you actually liked about him. You know, looked at in one way, he’s done you a favor.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p261"
    }
  }, [_vm._v("“Doesn’t feel like it.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p262"
    }
  }, [_vm._v("“No, he has. While you were going out with "), _c('i', [_vm._v("him")]), _vm._v(", you were never going to meet the right person for "), _c('i', [_vm._v("you")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p263"
    }
  }, [_vm._v("“He managed to find someone.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p264"
    }
  }, [_vm._v("“Men are like dogs, Jen. Even Rupert.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p265"
    }
  }, [_vm._v("“But Rupert wouldn’t—”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p266"
    }
  }, [_vm._v("“No, he wouldn’t. But an "), _c('i', [_vm._v("eye")]), _vm._v(" for other women is okay, is actually healthy. As Rupert always says, just because you’re on a diet doesn’t mean you can’t look at the menu.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p267"
    }
  }, [_vm._v("“Though if he—”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p268"
    }
  }, [_vm._v("“If he had so much as a nibble, I’d have his balls for earrings.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p269"
    }
  }, [_vm._v("There is laughter. More Chilean Sauvignon Blanc splashes into our glasses.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p270"
    }
  }, [_vm._v("“You know who you need, Jen?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p271"
    }
  }, [_vm._v("“Who?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p272"
    }
  }, [_vm._v("“A grown-up. Early forties. Maybe mid. Perhaps someone who’s been married and it’s gone tits up. A bit of a wounded bird. With blood in his veins, not ice water.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p273"
    }
  }, [_vm._v("“Ooh, I like the sound of him. What’s his name?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p274"
    }
  }, [_vm._v("“Dunno. Douglas!”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p275"
    }
  }, [_c('i', [_vm._v("“Douglas!?”")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p276"
    }
  }, [_vm._v("“He’s got a sad smile. And lovely arms. And he makes his own furniture and maybe there are kids and he’s got a cock like a "), _c('i', [_vm._v("conger")]), _vm._v(" "), _c('i', [_vm._v("eel")]), _vm._v("!”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p277"
    }
  }, [_vm._v("“Ingrid!?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p278"
    }
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p279"
    }
  }, [_vm._v("“I think that waiter heard you.”")]), _vm._v(" "), _c('div', {
    staticClass: "decoration-rw",
    attrs: {
      "id": "decoration5"
    }
  }, [_c('p', {
    staticClass: "center-rw",
    attrs: {
      "id": "p280"
    }
  }, [_vm._v("*  *  *")])]), _vm._v(" "), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p281"
    }
  }, [_vm._v("I find a Facebook message from Rosy when I get home. It’s not a bad time for us to talk—my late night, her late afternoon—so I bash out a reply. I tell her about my evening, Rosy being hungry for tales of Merrie Olde London Towne, as she puts it.")]), _vm._v(" "), _c('div', {
    staticClass: "block-rw dialogue-rw",
    attrs: {
      "id": "dialogue1"
    }
  }, [_c('p', {
    attrs: {
      "id": "p4712"
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p282"
    }
  }, [_vm._v("Ingrid thinks I should meet someone called Douglas with a sad smile and lovely arms. He makes his own furniture.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p283"
    }
  }, [_c('i', [_vm._v("He sounds cool. When’s it gonna happen?")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p284"
    }
  }, [_vm._v("It’s not. She made him up.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p285"
    }
  }, [_c('i', [_vm._v("Shame. I liked the sound of him.")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p286"
    }
  }, [_vm._v("Me too. I could do with some new shelves.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p287"
    }
  }, [_c('i', [_vm._v("Haha. But she’s right. You deserve someone great. And you will find them. Or rather, they will find you.")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p288"
    }
  }, [_vm._v("You believe that?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p289"
    }
  }, [_c('i', [_vm._v("You will find each other.")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p290"
    }
  }, [_vm._v("Yeah, right. Like you and Larry, at Waitrose #fluke #howjammycanyouget #skeptical")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p291"
    }
  }, [_c('i', [_vm._v("You can’t go looking for it, Jen. It’s only when you’re not looking that it happens. All you can do is make sure you’re not sitting alone in your room.")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p292"
    }
  }, [_vm._v("Hmm. Tell you what I definitely DO believe. That you know when it’s the right person, because they’re singing a song only you can hear.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p293"
    }
  }, [_c('i', [_vm._v("Oscar Wilde?")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p294"
    }
  }, [_vm._v("Read it on Twitter.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p295"
    }
  }, [_c('i', [_vm._v("Did Matt sing in your head?")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p296"
    }
  }, [_vm._v("Once maybe. Can’t remember. Larry?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p297"
    }
  }, [_c('i', [_vm._v("Larry sings in the car. The girls tell him to zip it.")])])]), _vm._v(" "), _c('div', {
    staticClass: "decoration-rw",
    attrs: {
      "id": "decoration6"
    }
  }, [_c('p', {
    staticClass: "center-rw",
    attrs: {
      "id": "p298"
    }
  }, [_vm._v("*  *  *")])]), _vm._v(" "), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p299"
    }
  }, [_vm._v("When the chat ends, I discover an e-mail from Matt. It’s a very “Mattish” communication, asking if I know anything about a payment he has apparently made to a feminist collective in Lancaster for 2,000 pounds. He is pursuing the error “vigorously” with his bank, and has been advised by their security people as part of the investigation to check with anyone who may have had recent access to his online banking details. As though I am expected to care, he adds he’s had a shitty day at work for reasons he does not elaborate, and “to cap off a really shitty week,” HMRC has chosen him to be the subject of one of their routine tax investigations. His name was chosen at random by their computer. They will want to see all his records going back five years. According to Frobisher in his firm’s tax division, the process is, “Like being sodomized with a splintery broom handle, only less fun.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p300"
    }
  }, [_vm._v("Is he actually feeling guilty about how he’s behaved, and is therefore feeding me stories about how fate is conspiring to crap on him?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p301"
    }
  }, [_vm._v("Don’t be silly. Resisting the urge to type "), _c('i', [_vm._v("HA HA HA HA BLOODY HA")]), _vm._v(", I simply reply:")]), _vm._v(" "), _c('div', {
    staticClass: "block-rw",
    attrs: {
      "id": "communication-email1"
    }
  }, [_c('p', {
    staticClass: "ecom-a-first-rw",
    attrs: {
      "id": "p302"
    }
  }, [_vm._v("Don’t know anything about this. Can’t help. Sorry.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-rw",
    attrs: {
      "id": "p303"
    }
  }, [_vm._v("Which is all true.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p304"
    }
  }, [_vm._v("Except the sorry part.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c533b00","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/s008-Chapter-002.vue
// module id = 84
// module chunks = 0